import React from 'react';

import { constants } from '../../../common/Localization';
import AWSCATTable from '../../../common/table/Table-index';
import { DetailsTabProps, Resource, SizeAssessment } from './MainframeTypes';
import { MainframeResourceColumnDefinitions } from './ResourceColumnDefinitions';

function DetailsTab(props: DetailsTabProps) {
    const resources = convertResources(props.resources);

    function convertResources(sizeAssessment: SizeAssessment[]): Resource[] {
        const mainframeResources = new Array<Resource>();
        sizeAssessment.forEach(mf => {
            const mainframeName = mf.mainframeName as string;
            mf.mainframeEnvMatches.forEach(envMatch => {
                const environmentType = envMatch.environment as string;
                Object.values(envMatch)
                    .filter(o => typeof o === 'object')
                    .forEach((resource: any) => {
                        let count = resource.count;
                        if (typeof count !== 'number') {
                            count = Number(count);
                        }
                        if (resource.isDisabled) {
                            return;
                        }
                        mainframeResources.push({
                            count,
                            currency: props.currency,
                            environmentType,
                            isDisasterRecovery: resource.isDisasterRecovery ? 'Yes' : 'No',
                            mainframeName,
                            monthlyCost: resource.monthlyCost,
                            resourceName: resource.label,
                            resourceType: resource.type,
                            unit: resource.unit,
                            unitMonthlyCost: resource.unitMonthlyCost,
                        });
                    });
            });
        });
        return mainframeResources;
    }

    return (
        <AWSCATTable
            resourceName={constants.RESOURCES}
            columnDefinitions={MainframeResourceColumnDefinitions}
            items={resources}
            autoGenerateVisibleContent
            enableAutoSorting
            useDefaultDownload
        />
    );
}

export default DetailsTab;
